export const ESTIMATE = {
    SET_OBJET: 'ESTIMATE_SET_OBJET',
    SET_DESCRIPTIF: 'ESTIMATE_SET_DESCRIPTIF',
    SET_DATE: 'ESTIMATE_SET_DATE',
    SET_CHANTIER: 'ESTIMATE_SET_CHANTIER',
    RESET_ESTIMATE: 'ESTIMATE_RESET_ESTIMATE',
    SET_LOADING: 'ESTIMATE_SEND_SET_LOADING',
    SET_FILES: 'ESTIMATE_SET_FILES',
    SET_SUCCESS: 'ESTIMATE_SEND_SET_SUCCESS',
    SET_ERROR: 'ESTIMATE_SEND_SET_ERROR',
    SET_STEP: 'ESTIMATE_SET_STEP',
    SET_RESPONSE: 'ESTIMATE_SET_RESPONSE',
    ADD_FILE: 'ESTIMATE_ADD_FILE',
    REMOVE_FILE : 'ESTIMATE_REMOVE_FILE',
    SET_EDITING: 'ESTIMATE_SET_EDITING',
    SET_EDITING_ID: 'ESTIMATE_SET_EDITING_ID',
    SET_INITIAL_DRAFT: 'ESTIMATE_SET_INITIAL_DRAFT',
};
